
















































































import { Task, TaskGroup } from "@/tasks";
import moment from "moment";
import { TaskFilterOption } from "../../enums";
import { AppComponent, AppInjects } from "@/App.vue";
import Utils from "@/utils";
export default AppComponent.extend({
    name: "TasksFilter",
    props: {
        value: Array as () => Task[],
        allTasks: Array as () => Task[],
        notifications: Boolean,
        filter: String as () => TaskFilterOption,
        taskgroups: Array as () => string[],
        teamMode: Boolean,
        searchText: String
    },
    inject: AppInjects,
    components: {},
    data: () => {
        return {
            groups: [] as TaskGroup[],
            localTaskGroups: [] as string[],
            rerender: 0
        };
    },
    mounted() {
        this.localTaskGroups = this.taskgroups;
        if (this.notifications) this.filterNotifications();
        else this.filterTasks(true, false);
    },
    watch: {
        postponedTasks() {
            this.filterTasks(true, false);
        },
        deletedNotifications() {
            this.filterNotifications();
        },
        filter() {
            this.filterTasks(true);
        },
        searchText() {
            if (this.notifications) {
                this.filterNotifications();
            } else {
                this.filterTasks(true, false);
            }
        },
        localTaskGroups: {
            deep: true,
            handler(): void {
                this.filterGroupChanged();
            }
        },
        allTasks: {
            deep: true,
            handler(): void {
                this.filterTasks(true, false);
            }
        }
    },
    computed: {
        myNotifications(): Task[] {
            return this.filterOnSearchText(this.allTasks) || [];
        },
        deletedNotifications(): Task[] {
            return (this.allTasks || []).filter(x => x.finished == true);
        },
        myTasks(): Task[] {
            return (this.filterOnSearchText(this.allTasks) || []).filter(
                x => (this.teamMode || x.assigned_to_user != null) && (!x.postponed_until_date || x.postponed_until_date <= moment().toDate())
            );
        },
        postponedTasks(): Task[] {
            return (this.filterOnSearchText(this.allTasks) || []).filter(x => x.postponed_until_date && x.postponed_until_date > moment().toDate());
        },
        notAssignedTasks(): Task[] {
            return (this.filterOnSearchText(this.allTasks) || []).filter(x => x.assigned_to_user == null);
        }
    },
    methods: {
        /**
         * Filter a set of tasks based on the searchtext
         */
        filterOnSearchText(tasks: Task[]): Task[] {
            let searchedTasks: Task[] = tasks;
            const normSearchText = Utils.normalize(this.searchText);
            if (normSearchText) {
                searchedTasks = tasks.filter(item => {
                    return Utils.normalize(item.title).includes(normSearchText) || Utils.normalize(item.description).includes(normSearchText);
                });
            }
            return searchedTasks;
        },
        /**
         * Filter all tasks based on search text and selected groups
         */
        filterTasks(refreshTaskGroups: boolean, resetSelection: boolean = true): void {
            // Get tasks with search filter applied
            let searchedTasks: Task[] = [];
            switch (this.filter) {
                case TaskFilterOption.My:
                    searchedTasks = this.myTasks;
                    break;
                case TaskFilterOption.Postponed:
                    searchedTasks = this.postponedTasks;
                    break;
                case TaskFilterOption.NotAssigned:
                    searchedTasks = this.notAssignedTasks;
                    break;
            }

            // add filter based on selected groups
            const searchedAndFilteredTasks = this.filterOnSelectedGroups(searchedTasks);

            // emit model update
            this.$emit("input", searchedAndFilteredTasks);

            // update groups based on search text
            if (refreshTaskGroups) {
                this.setGroups(searchedTasks, resetSelection);
                this.rerender++; //Forces to rerender group filter
            }
        },
        /**
         * Filter all notification based on search text and selected groups
         */
        filterNotifications(): void {
            // get all notifications with search filter applied
            let searchedNotifications: Task[] = this.myNotifications;

            const searchedAndFilteredNotifications = this.filterOnSelectedGroups(searchedNotifications);
            this.$emit("input", searchedAndFilteredNotifications);

            this.setGroups(searchedNotifications, false);
            this.rerender++; //Forces to rerender group filter
        },
        /**
         * Set groups based on a list of Tasks
         */
        setGroups(items: Task[], resetSelection: boolean): void {
            this.groups = [];
            for (const item of items || []) {
                let group = this.groups.find(x => x.fixed_name == item.group.fixed_name);
                if (!group) {
                    let group = item.group;
                    group.count = 1;
                    this.groups.push(group);
                } else {
                    group.count++;
                }

                if (resetSelection) this.localTaskGroups.splice(0, this.localTaskGroups.length);
            }
            this.groups.sort((a, b) => a.group_id - b.group_id);
            this.$emit("update:taskgroups", this.localTaskGroups);
        },
        /**
         * filter a list of tasks on selected groups
         */
        filterOnSelectedGroups(tasks: Task[]): Task[] {
            const existingTaskGroups = this.localTaskGroups.filter(taskGroup => tasks.filter(y => y.group.fixed_name == taskGroup).length > 0);
            if (existingTaskGroups.length > 0) {
                return tasks.filter(task => existingTaskGroups.indexOf(task.group.fixed_name) > -1);
            }
            return tasks;
        },
        /**
         * Update filter when changing the group selection
         */
        filterGroupChanged(): void {
            if (this.notifications) this.filterNotifications();
            else this.filterTasks(true, false);
        },
        filterChanged(newValue: string, old: string) {
            this.$emit("update:filter", newValue);
            this.startCampaign();
        },
        startCampaign() {
            this.$startCampaign("MyTasks-Filters");
        }
    }
});
